import React from 'react';
import styled from 'styled-components';
import { useCurrencyStore } from '../../store/useCurrencyStore';

const Select = styled.select`
  height: 42px;
  padding: 0 12px;
  border-radius: 12px;
  background: var(--card);
  color: inherit;
  border: 1px solid var(--bdr);
  box-shadow: var(--shadow);
  min-width: 90px;
`;

export default function CurrencySwitcher(){
  const currency = useCurrencyStore(s => s.currency);
  const setCurrency = useCurrencyStore(s => s.setCurrency);

  const handleCurrencyChange = (e) => {
    const newCurrency = e.target.value;
    setCurrency(newCurrency);
  };

  return (
    <Select 
      value={currency} 
      onChange={handleCurrencyChange} 
      aria-label="Курс валют"
    >
      <option value="RUB">RUB</option>
      <option value="USD">USD</option>
      <option value="EUR">EUR</option>
      <option value="AED">AED</option>
    </Select>
  );
}
